import React, { Component, Fragment } from 'react';
import { Button, Card, Table, Tag, Icon, Modal } from 'antd';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';

@inject('store')
@observer
export class ManageListings extends Component {
    constructor(props) {
        super(props);

        this.state = { listings: [] };
    }

    async componentDidMount() {
        try {
            const { data } = await this.props.store.stratCenter.getUserListings();

            this.setState({ listings: data.listings });
        } catch (e) {}
    }

    render() {
        return (
            <Card
                title={'My Listings'}
                extra={
                    <Button
                        type="primary"
                        onClick={() => this.props.history.push('/a/strat-center/my-listings/new')}
                    >
                        Create Listing
                    </Button>
                }
                bordered={false}
            >
                <Table
                    rowKey="_id"
                    dataSource={this.state.listings}
                    columns={[
                        {
                            title: 'Availability',
                            dataIndex: 'availability',
                            key: 'availability',
                            width: 50,
                            render: (text, o) => (
                                <Tag color={text === 'public' ? '#436b45' : '#793348'}>
                                    {this.caps(text)}
                                </Tag>
                            )
                        },
                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            render: (text, o) => (
                                <Link to={`/a/strat-center/listing/${o._id}`}>
                                    <Icon type="share-alt" /> {text}
                                </Link>
                            )
                        },
                        {
                            title: 'Bot',
                            dataIndex: 'bot_type',
                            key: 'bot_type',
                            render: (text, o) => (
                                <Tag color={'#a187ff'}>{this.caps(text || 'Apex')}</Tag>
                            )
                        },
                        {
                            title: 'Type',
                            dataIndex: 'listing_type',
                            key: 'listing_type',
                            render: (text, o) => <Tag color={'#a187ff'}>{this.caps(text)}</Tag>
                        },
                        {
                            title: 'Supported Base',
                            dataIndex: 'supported_base',
                            key: 'supported_base',
                            render: (text, o) => text.map(base => <Tag key={base}>{base}</Tag>)
                        },
                        {
                            title: 'Actions',
                            dataIndex: 'actions',
                            key: 'actions',
                            render: (text, o) => {
                                return (
                                    <Fragment>
                                        <Button
                                            type={'primary'}
                                            onClick={() =>
                                                this.props.history.push(
                                                    `/a/strat-center/my-listings/${o._id}/edit`
                                                )
                                            }
                                        >
                                            Edit
                                        </Button>
                                        &nbsp;&nbsp;
                                        <Button
                                            onClick={() => {
                                                Modal.confirm({
                                                    title: 'Are you sure delete this listing?',
                                                    content: o.name,
                                                    okText: 'Yes',
                                                    okType: 'danger',
                                                    cancelText: 'No',
                                                    onOk: async () => {
                                                        await this.props.store.stratCenter.delete(
                                                            o._id
                                                        );
                                                        const {
                                                            data
                                                        } = await this.props.store.stratCenter.getUserListings();
                                                        this.setState({ listings: data.listings });
                                                    },
                                                    onCancel() {}
                                                });
                                            }}
                                            type={'danger'}
                                        >
                                            Delete
                                        </Button>
                                    </Fragment>
                                );
                            }
                        }
                    ]}
                />
            </Card>
        );
    }

    caps(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}



// WEBPACK FOOTER //
// ./src/Account/StratCenter/Listings/index.js